export default "__VITE_ASSET__mQ1chtekZdgYYVLLU5nvgg__"